import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Breadcrumbs, Button, TextField, Typography } from '@mui/material';
import AppShell from './components/AppShell';
import api from './services/api';

const AddProjectForm = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await api.post('/projects/', { name });
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to create project.');
    }
  };

  return (
    <AppShell maxWidth="sm">
      <Breadcrumbs separator=">" sx={{ mb: 3 }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>Home</Link>
        <Typography color="textPrimary">New Project</Typography>
      </Breadcrumbs>

      <Box
        sx={{
          bgcolor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: 3,
          p: 4,
        }}
      >
        <Typography variant="h5" fontFamily="'Work Sans', sans-serif" fontWeight={700} gutterBottom>
          Create a New Project
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            fullWidth
            label="Project Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            margin="normal"
          />
          {error && <Typography color="error" variant="body2" sx={{ mt: 1 }}>{error}</Typography>}
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 2, borderRadius: 2, textTransform: 'none', py: 1.2 }}
          >
            Create Project
          </Button>
        </Box>
      </Box>
    </AppShell>
  );
};

export default AddProjectForm;
